import { useTranslation } from 'react-i18next';
import StatisticsPlaceholderImg from './img/statistics-placeholder.svg';

export default function EmptyContainer() {
  const {t} = useTranslation()
  return (
    <div className="d-flex align-items-center justify-content-center mt-5 flex-column text-center">
      <img
        src={StatisticsPlaceholderImg}
        alt=""
        className="mb-4 mt-5 pt-5 col-8 col-sm-6 col-lg-auto"
        style={{ maxWidth: 396 }}
      />
      <p className="text-gray mb-0">{t('ticketStatistic.noStatisticsYet')}</p>
      <p className="text-gray mb-0 px-3" style={{ maxWidth: 360 }}>
        {t('ticketStatistic.createEvent')}
      </p>
    </div>
  );
};